<!--服务器正在维护mask -->
<template>
  <div id="updating-container" class="flx-center">
    <div class="content">
      <Icon svg-type="server-updating" :iconStyle="{ width: '300px', height: '300px' }" />
      <div class="updating-text">服务器正在维护，请稍等...</div>
      <div style="width: 320px; margin: 7px auto">
        <FakeProgress :showhintText="false" ref="fakeProgressRef" :step="1" status="" :interval="800" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import Icon from '@/components/Icon/index.vue'
import FakeProgress from '@/components/FakeProgress/index.vue'
import { onMounted, ref } from 'vue'
let fakeProgressRef = ref()
onMounted(() => {
  console.log('mounted')
  // 禁止回退前进
  prohibitOperation()
  fakeProgressRef.value && fakeProgressRef.value.start()
})

function doneProgress() {
  fakeProgressRef.value.finish('success')
}
defineExpose({ doneProgress })

function prohibitOperation() {
  if (typeof window.history.pushState === 'function') {
    window.history.pushState('jibberish', '', '')
    window.onpopstate = function () {
      window.history.pushState('newjibberish', '', '')
    }
  }
}
</script>
<style scoped lang="scss">
@import './index.scss';
</style>
